import loadQueries from './load-queries.action';

export default loadQueries;
